import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import catIcon from "../../assets/Icon/category icon.svg";
import productIcon from "../../assets/Icon/Product icon.svg";
import salesIcon from "../../assets/Icon/sales Icon.svg";
import invoiceIcon from "../../assets/Icon/invoice icon.svg";
import { useHistory, useParams } from "react-router-dom";
import { logout_func2 } from "../Const/logoutCommon";
import axios from "axios";
import { BASE_URL } from "../Const/Url";
import Loader from "../CustomCommons/Loader";
import swal from "sweetalert";
import { showToast } from "../../utils/ToastHelper";
import ViewIcon from "../CustomCommons/ViewIcon";
import EditIcon from "../CustomCommons/EditIcon";
import DeleteIcon from "../CustomCommons/DeleteIcon";
import NextIcon from "../CustomCommons/NextIcon";
import PreviousIcon from "../CustomCommons/PreviousIcon";
import {
  can_change_invoice,
  can_delete_invoice,
  can_view_invoice,
  has_permissions,
} from "../CustomCommons/utils";
import { Link } from "react-router-dom";
import SalesFilter from "../dashboard/SalesFilter";
import ExchangeOutletList from "./ExchangeOutletList";

const ViewOutlet = () => {
  const [OnlogoutHide, setOnlogoutHide] = useState(0);
  const history = useHistory();
  const { id } = useParams();
  const [outletData, setOutletData] = useState({});
  const [outlet, setOutlet] = useState({});
  const [loading, setLoading] = useState(true);
  const getOutlet = () => {
    const url = `${BASE_URL}api/v1/auth/dashboard/?outlet=${id}`;
    axios
      .get(url)
      .then((res) => {
        const result = res.data.data;
        setOutletData(result);
        setLoading(false);
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        if (
          message === "Invalid token." ||
          JSON.parse(err.request.response).code === 401
        ) {
          // history.push('/login')
          logout_func2(setOnlogoutHide, history);
        }
        // console.log(err.request.response);
      });
  };
  const getOutletName = () => {
    const url = `${BASE_URL}api/v1/sales/admin/outlet/${id}/`;
    axios
      .get(url)
      .then((res) => {
        const result = res.data.data;
        setOutlet(result);
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        if (
          message === "Invalid token." ||
          JSON.parse(err.request.response).code === 401
        ) {
          // history.push('/login')
          logout_func2(setOnlogoutHide, history);
        }
        // console.log(err.request.response);
      });
  };
  useEffect(() => {
    getOutlet();
    getOutletName();
  }, []);

  const [date1, setDate1] = useState("");
  const [date2, setDate2] = useState("");
  const [query, setQuery] = useState("");

  // ofset code
  const [totalData, setTotalData] = useState(0);
  const [items_data, setItems_data] = useState([]);
  const [total_item, setTotal_item] = useState(0);
  const [isLoading2, SetisLoading2] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const [selectedInvoiceIds, setSelectedInvoiceIds] = useState([]);

  // Hidden invoices states
  const [totalDataHidden, setTotalDataHidden] = useState(0);
  const [items_data_hidden, setItems_data_hidden] = useState([]);
  const [total_item_hidden, setTotal_item_hidden] = useState(0);
  const [pageNumberHidden, setPageNumberHidden] = useState(1);
  const [nextUrlHidden, setNextUrlHidden] = useState(null);
  const [prevUrlHidden, setPrevUrlHidden] = useState(null);
  const [selectedHiddenInvoiceIds, setSelectedHiddenInvoiceIds] = useState([]);
  const [queryHidden, setQueryHidden] = useState("");

  const limit = 20;
  const item_limit = pageNumber * limit;
  const this_page_items_show =
    item_limit > total_item ? total_item : item_limit;
  const page_show_start = item_limit - limit + 1;
  const pageCount = Math.ceil(total_item / limit);
  const indexOfLastPost = pageCount < pageNumber ? limit : pageNumber * limit;
  const offset = pageCount < pageNumber ? 0 : indexOfLastPost - limit;

  const apiFunction = (url) => {
    axios
      .get(url)
      .then((res) => {
        // setInvoiceList(res.data.data.results);

        setTotal_item(res.data?.data?.count);
        setTotalData(res.data?.data?.count);
        setItems_data(res.data?.data?.results);
        setNextUrl(res.data?.data?.next);
        setPrevUrl(res.data?.data?.previous);

        // console.log(res.data);
        // SetisLoading(false);
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        console.log(err.request.response);
        if (
          message === "Invalid token." ||
          JSON.parse(err.request.response).code === 401
        ) {
          // history.push('/login')
          logout_func2(setOnlogoutHide, history);
        }
      });
  };

  // API function for hidden invoices
  const apiFunctionHidden = (url) => {
    axios
      .get(url)
      .then((res) => {
        setTotal_item_hidden(res.data?.data?.count);
        setTotalDataHidden(res.data?.data?.count);
        setItems_data_hidden(res.data?.data?.results);
        setNextUrlHidden(res.data?.data?.next);
        setPrevUrlHidden(res.data?.data?.previous);
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        console.log(err.request.response);
        if (
          message === "Invalid token." ||
          JSON.parse(err.request.response).code === 401
        ) {
          logout_func2(setOnlogoutHide, history);
        }
      });
  };

  useEffect(() => {
    apiFunction(
      `${BASE_URL}${"api/v1/sales/inventory/invoice/"}?limit=${limit}&offset=${offset}&query=${query}&outlet=${id}&is_exchanged=false&is_hidden=false`
    );
    // Fetch hidden invoices on initial load
    const pageCountHidden = Math.ceil(total_item_hidden / limit);
    const indexOfLastPostHidden =
      pageCountHidden < pageNumberHidden ? limit : pageNumberHidden * limit;
    const offsetHidden =
      pageCountHidden < pageNumberHidden ? 0 : indexOfLastPostHidden - limit;
    apiFunctionHidden(
      `${BASE_URL}${"api/v1/sales/inventory/invoice/"}?limit=${limit}&offset=${offsetHidden}&query=${queryHidden}&outlet=${id}&is_exchanged=false&is_hidden=true`
    );
  }, []);

  const handlePaginationPrevious = () => {
    apiFunction(prevUrl);
    setPageNumber((prev) => {
      if (prev > 1) {
        return prev - 1;
      } else {
        return prev;
      }
    });
    // SetisLoading(false)
  };
  const handlePaginationNext = () => {
    // SetisLoading(true);
    apiFunction(nextUrl);
    setPageNumber((prev) => prev + 1);
    // SetisLoading(false)
  };
  const handleChangeCurrentPage = (val) => {
    setPageNumber(val);
  };

  // Pagination handlers for hidden invoices
  const handlePaginationPreviousHidden = () => {
    apiFunctionHidden(prevUrlHidden);
    setPageNumberHidden((prev) => {
      if (prev > 1) {
        return prev - 1;
      } else {
        return prev;
      }
    });
  };

  const handlePaginationNextHidden = () => {
    apiFunctionHidden(nextUrlHidden);
    setPageNumberHidden((prev) => prev + 1);
  };

  const handleChangeCurrentPageHidden = (val) => {
    setPageNumberHidden(val);
  };

  const pageCountHidden = Math.ceil(total_item_hidden / limit);

  // Function to handle hiding invoices
  const handleHideInvoices = () => {
    if (selectedInvoiceIds.length === 0) {
      showToast("error", "Please select at least one invoice to hide");
      return;
    }

    // Get invoice numbers from selected invoice IDs
    const invoiceNumbers = items_data
      .filter((invoice) => {
        const invoiceId = invoice.slug || invoice.id;
        return selectedInvoiceIds.includes(invoiceId);
      })
      .map((invoice) => invoice.number)
      .filter((number) => number); // Filter out any undefined/null values

    if (invoiceNumbers.length === 0) {
      showToast(
        "error",
        "Could not find invoice numbers for selected invoices"
      );
      return;
    }

    // Show confirmation dialog
    swal({
      title: "Are you sure?",
      text: `Do you want to hide ${invoiceNumbers.length} invoice(s)?`,
      icon: "warning",
      buttons: {
        cancel: {
          text: "Cancel",
          value: false,
          visible: true,
          className: "",
          closeModal: true,
        },
        confirm: {
          text: "Yes, Hide Them",
          value: true,
          visible: true,
          className: "btn-danger",
          closeModal: true,
        },
      },
      dangerMode: true,
    }).then((willHide) => {
      if (willHide) {
        // Make API call to hide invoices
        axios
          .post(`${BASE_URL}api/v1/sales/inventory/v2/invoice-products/script/`, {
            is_hidden: true,
            invoice_ids: invoiceNumbers,
          })
          .then((res) => {
            showToast("success", "Invoices hidden successfully");
            // Clear selected invoices
            setSelectedInvoiceIds([]);
            // Reload both tables
            const pageCountHidden = Math.ceil(total_item_hidden / limit);
            const indexOfLastPostHidden =
              pageCountHidden < pageNumberHidden
                ? limit
                : pageNumberHidden * limit;
            const offsetHidden =
              pageCountHidden < pageNumberHidden
                ? 0
                : indexOfLastPostHidden - limit;
            apiFunction(
              `${BASE_URL}api/v1/sales/inventory/invoice/?limit=${limit}&offset=${offset}&query=${query}&outlet=${id}&is_exchanged=false&is_hidden=false`
            );
            apiFunctionHidden(
              `${BASE_URL}api/v1/sales/inventory/invoice/?limit=${limit}&offset=${offsetHidden}&query=${queryHidden}&outlet=${id}&is_exchanged=false&is_hidden=true`
            );
          })
          .catch((err) => {
            console.error("Error hiding invoices:", err);
            const errorMessage =
              err.response?.data?.message ||
              err.message ||
              "Failed to hide invoices";
            showToast("error", errorMessage);
          });
      }
    });
  };

  // Function to handle showing invoices (unhiding)
  const handleShowInvoices = () => {
    if (selectedHiddenInvoiceIds.length === 0) {
      showToast("error", "Please select at least one invoice to show");
      return;
    }

    // Get invoice numbers from selected hidden invoice IDs
    const invoiceNumbers = items_data_hidden
      .filter((invoice) => {
        const invoiceId = invoice.slug || invoice.id;
        return selectedHiddenInvoiceIds.includes(invoiceId);
      })
      .map((invoice) => invoice.number)
      .filter((number) => number); // Filter out any undefined/null values

    if (invoiceNumbers.length === 0) {
      showToast(
        "error",
        "Could not find invoice numbers for selected invoices"
      );
      return;
    }

    // Show confirmation dialog
    swal({
      title: "Are you sure?",
      text: `Do you want to show ${invoiceNumbers.length} invoice(s)?`,
      icon: "warning",
      buttons: {
        cancel: {
          text: "Cancel",
          value: false,
          visible: true,
          className: "",
          closeModal: true,
        },
        confirm: {
          text: "Yes, Show Them",
          value: true,
          visible: true,
          className: "btn-primary",
          closeModal: true,
        },
      },
    }).then((willShow) => {
      if (willShow) {
        // Make API call to show invoices (set is_hidden to false)
        axios
          .post(`${BASE_URL}api/v1/sales/inventory/v2/invoice-products/script/`, {
            is_hidden: false,
            invoice_ids: invoiceNumbers,
          })
          .then((res) => {
            showToast("success", "Invoices shown successfully");
            // Clear selected invoices
            setSelectedHiddenInvoiceIds([]);
            // Reload both tables
            const pageCountHidden = Math.ceil(total_item_hidden / limit);
            const indexOfLastPostHidden =
              pageCountHidden < pageNumberHidden
                ? limit
                : pageNumberHidden * limit;
            const offsetHidden =
              pageCountHidden < pageNumberHidden
                ? 0
                : indexOfLastPostHidden - limit;
            apiFunction(
              `${BASE_URL}api/v1/sales/inventory/invoice/?limit=${limit}&offset=${offset}&query=${query}&outlet=${id}&is_exchanged=false&is_hidden=false`
            );
            apiFunctionHidden(
              `${BASE_URL}api/v1/sales/inventory/invoice/?limit=${limit}&offset=${offsetHidden}&query=${queryHidden}&outlet=${id}&is_exchanged=false&is_hidden=true`
            );
          })
          .catch((err) => {
            console.error("Error showing invoices:", err);
            const errorMessage =
              err.response?.data?.message ||
              err.message ||
              "Failed to show invoices";
            showToast("error", errorMessage);
          });
      }
    });
  };

  useEffect(() => {
    if (pageCount !== 0) {
      if (pageCount < pageNumber) {
        setPageNumber(pageCount);
      }
    }
  }, [pageCount]);

  useEffect(() => {
    if (pageNumber > 1 || query) {
      apiFunction(
        `${BASE_URL}${"api/v1/sales/inventory/invoice/"}?limit=${limit}&offset=${offset}&query=${query}&is_custom=false&outlet=${id}&is_exchanged=false&is_hidden=false`
      );
    }
  }, [pageNumber, query]);

  // useEffect for hidden invoices pagination and query
  useEffect(() => {
    const pageCountHidden = Math.ceil(total_item_hidden / limit);
    const indexOfLastPostHidden =
      pageCountHidden < pageNumberHidden ? limit : pageNumberHidden * limit;
    const offsetHidden =
      pageCountHidden < pageNumberHidden ? 0 : indexOfLastPostHidden - limit;

    if (pageNumberHidden > 1 || queryHidden) {
      apiFunctionHidden(
        `${BASE_URL}${"api/v1/sales/inventory/invoice/"}?limit=${limit}&offset=${offsetHidden}&query=${queryHidden}&is_custom=false&outlet=${id}&is_exchanged=false&is_hidden=true`
      );
    }
  }, [pageNumberHidden, queryHidden]);

  useEffect(() => {
    if (pageCountHidden !== 0) {
      if (pageCountHidden < pageNumberHidden) {
        setPageNumberHidden(pageCountHidden);
      }
    }
  }, [pageCountHidden]);

  // ofset code
  const updatedPageNumber = parseInt(
    localStorage.getItem("invoicePageNbr")
      ? localStorage.getItem("invoicePageNbr")
      : 0
  );
  // const [pageNumber, setPageNumber] = useState(updatedPageNumber);
  const usersPerPage = 15;
  const pagesVisited = pageNumber * usersPerPage;

  const [invoiceList, setInvoiceList] = useState([]);
  const [checkedIds, setCheckedIds] = useState([]);

  const invoice_choices = ["Recieved", "Exchange", "Refunded", "Exchange"];

  const delivery_choices = [
    "Returned",
    "Order Placed",
    "Delivered",
    "Pending",
    "Hold",
    "Dispached",
  ];
  //  const invoice_choices = [
  // { value: 0, label: "Recieved" },
  // { value: 1, label: "Exchange" },
  // { value: 2, label: "Refunded" },
  // { value: 3, label: "Exchange" },
  // ];
  const delivery_type_choices = ["Regular", "Urgent"];
  const paymentType = [
    "Cash",
    "Card",
    "Bank Transfer",
    "bKash",
    "SSLECOMMERZ",
    "Nagad",
    "KOD",
    "Rocket",
    "Mixed",
  ];
  const date = new Date();
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  let currentDate = `${month}-${day}-${year}`;
  var options = {
    day: "numeric",
    year: "numeric",
    month: "numeric",
  };
  // const HandlePrint = useReactToPrint({
  //   content: () => cRef.current,
  //   documentTitle: "Daily Sales Report",
  //   // onAfterPrint: () => swal("Printed"),
  //   bodyClass: "dis",
  // });
  // const handlePrints = () => {
  //   HandlePrint();
  // };

  const getInvoiceList = () => {
    let url;
    if (date1 && date2) {
      url = `${BASE_URL}api/v1/sales/inventory/invoice/filter/?start=${date1}&end=${date2}&is_custom=false&outlet=${id}&is_exchanged=false`;
    } else {
      url = `${BASE_URL}api/v1/sales/inventory/invoice/?is_custom=false&outlet=${id}&is_exchanged=false`;
    }

    axios
      .get(url)
      .then((res) => {
        setInvoiceList(res.data.data.results);
        setTotal_item(res.data?.data?.count);
        setTotalData(res.data?.data?.count);
        setItems_data(res.data?.data?.results);
        setNextUrl(res.data?.data?.next);
        setPrevUrl(res.data?.data?.previous);

        // SetisLoading(false);
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        console.log(err.request.response);
      });
  };
  // useEffect(() => {
  //   getInvoiceList();
  // }, []);
  // console.log(data);

  const keys = ["number", "prepared_by", "delivery_status", "invoice_date"];
  const getData = invoiceList.filter((p) =>
    keys.some((key) => p[key]?.toString()?.toLowerCase()?.includes(query))
  );

  useEffect(() => {
    // getInvoiceList();
    if (date1 === "undefined/undefined/" && date2 === "undefined/undefined/") {
      swal("Please select  dates");
    }
  }, []);

  const deleteData = (id2) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this Data",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const url = `${BASE_URL}api/v1/sales/inventory/invoice/${id2}`;
        axios
          .delete(url)
          .then(() => {
            // getInvoiceList();
            apiFunction(
              `${BASE_URL}${"api/v1/sales/inventory/invoice/"}?limit=${limit}&offset=${offset}&query=${query}&is_custom=false&outlet=${id}&is_exchanged=false`
            );
          })
          .catch((err) => {
            const message = JSON.parse(err.request.response).message;
            console.log(err.request.response);
          });

        swal(" Your data has been deleted!", {
          icon: "success",
        });
      } else {
        swal("Your data is safe!");
      }
    });
  };

  if (loading) {
    return <Loader />;
  }
  return (
    <div>
      <div className="categorey-parent " style={{ height: "100%" }}>
        <div className="only-margin">
          <div className="d-flex gap-3 justify-content-center">
            <h4>Outlet Name : {outlet?.name}</h4>
            <h4>Outlet Location : {outlet?.location}</h4>
          </div>
          {/* <Cube/> */}
          <div className="  stat-box-main">
            <div className=" state-main  mt-2 bg-white">
              <div className="state-img-box">
                <img src={catIcon} width={26} height={24} alt="" />
              </div>
              <div className="mx-4 mb-2">
                <p>Total User</p>
                <h5 className="state-head">
                  <CountUp
                    end={outletData?.users ? outletData?.users : 0}
                    duration={1}
                  />
                </h5>
              </div>
            </div>

            <div className=" state-main  mt-2 bg-white">
              <div className="state-img-box">
                <img src={productIcon} width={26} height={24} alt="" />
              </div>
              <div className="mx-4 mb-2">
                <p>Total Product</p>
                <h5 className="state-head">
                  <CountUp
                    end={outletData?.product ? outletData?.product : 0}
                    duration={1}
                  />
                </h5>
              </div>
            </div>
            <div className=" state-main  mt-2 bg-white">
              <div className="state-img-box">
                <img src={salesIcon} width={26} height={24} alt="" />
              </div>
              <div className="mx-4 mb-2">
                <p>Total Sales</p>
                <h5 className="state-head">
                  ৳
                  <CountUp
                    end={outletData?.sales ? outletData?.sales : 0}
                    duration={0.2}
                  />
                </h5>
              </div>
            </div>
            <div className=" state-main  mt-2 bg-white">
              <div className="state-img-box">
                <img src={invoiceIcon} width={26} height={24} alt="" />
              </div>
              <div className="mx-4 mb-2">
                <p>Total Invoice</p>
                <h5 className="state-head">
                  <CountUp
                    end={outletData?.invoice ? outletData?.invoice : 0}
                    duration={1}
                  />

                  <span className="text-white">৳</span>
                </h5>
              </div>
            </div>
          </div>
          <div className="  stat-box-main">
            <div className=" state-main  mt-2 bg-white">
              <div className="state-img-box">
                <img src={catIcon} width={26} height={24} alt="" />
              </div>
              <div className="mx-4 mb-2">
                <p>Today Sales</p>
                <h5 className="state-head">
                  <CountUp
                    end={
                      outletData?.todays_sale_amount
                        ? outletData?.todays_sale_amount
                        : 0
                    }
                    duration={1}
                  />
                </h5>
              </div>
            </div>

            <div className=" state-main  mt-2 bg-white">
              <div className="state-img-box">
                <img src={productIcon} width={26} height={24} alt="" />
              </div>
              <div className="mx-4 mb-2">
                <p>This Week Sales</p>
                <h5 className="state-head">
                  <CountUp
                    end={
                      outletData?.weekly_sale_amount
                        ? outletData?.weekly_sale_amount
                        : 0
                    }
                    duration={1}
                  />

                  <span className="text-white">৳</span>
                </h5>
              </div>
            </div>
            <div className=" state-main  mt-2 bg-white">
              <div className="state-img-box">
                <img src={salesIcon} width={26} height={24} alt="" />
              </div>
              <div className="mx-4 mb-2">
                <p>This Month Sales</p>
                <h5 className="state-head">
                  ৳
                  <CountUp
                    end={
                      outletData?.monthly_sale_amount
                        ? outletData?.monthly_sale_amount
                        : 0
                    }
                    duration={0.2}
                  />
                </h5>
              </div>
            </div>
            <div className=" state-main  mt-2 bg-white">
              <div className="state-img-box">
                <img src={invoiceIcon} width={26} height={24} alt="" />
              </div>
              <div className="mx-4 mb-2">
                <p>Last Month Sales</p>
                <h5 className="state-head">
                  <CountUp
                    end={
                      outletData?.previous_month_sale_amount
                        ? outletData?.previous_month_sale_amount
                        : 0
                    }
                    duration={1}
                  />

                  <span className="text-white">৳</span>
                </h5>
              </div>
            </div>
          </div>
          <div className="  stat-box-main">
            <div className=" state-main  mt-2 bg-white">
              <div className="state-img-box">
                <img src={catIcon} width={26} height={24} alt="" />
              </div>
              <div className="mx-4 mb-2">
                <p>Today Discount</p>
                <h5 className="state-head">
                  <CountUp
                    end={
                      outletData?.todays_discount
                        ? outletData?.todays_discount
                        : 0
                    }
                    duration={1}
                  />
                </h5>
              </div>
            </div>

            <div className=" state-main  mt-2 bg-white">
              <div className="state-img-box">
                <img src={productIcon} width={26} height={24} alt="" />
              </div>
              <div className="mx-4 mb-2">
                <p>This Week Discount</p>
                <h5 className="state-head">
                  <CountUp
                    end={
                      outletData?.this_week_discount
                        ? outletData?.this_week_discount
                        : 0
                    }
                    duration={1}
                  />

                  <span className="text-white">৳</span>
                </h5>
              </div>
            </div>
            <div className=" state-main  mt-2 bg-white">
              <div className="state-img-box">
                <img src={salesIcon} width={26} height={24} alt="" />
              </div>
              <div className="mx-4 mb-2">
                <p>This Month Discount</p>
                <h5 className="state-head">
                  ৳
                  <CountUp
                    end={
                      outletData?.this_month_discount
                        ? outletData?.this_month_discount
                        : 0
                    }
                    duration={0.2}
                  />
                </h5>
              </div>
            </div>
            <div className=" state-main  mt-2 bg-white">
              <div className="state-img-box">
                <img src={invoiceIcon} width={26} height={24} alt="" />
              </div>
              <div className="mx-4 mb-2">
                <p>Last Month Discount</p>
                <h5 className="state-head">
                  <CountUp
                    end={
                      outletData?.last_month_discount
                        ? outletData?.last_month_discount
                        : 0
                    }
                    duration={1}
                  />

                  <span className="text-white">৳</span>
                </h5>
              </div>
            </div>
          </div>
          {/* sales filter */}
          <SalesFilter
            mid={"/api/v1/auth/dashboard-sales/"}
            secondParam={`&outlet=${id}`}
          />
        </div>

        <div className="invoice-main ">
          <div className="head-select my-2 d-flex justify-content-between align-items-center">
            <div>
              <h5>Outlet Invoice</h5>
              <input
                type="text"
                style={{ color: "black" }}
                className="filter-input"
                placeholder="Search here"
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
            </div>
            {selectedInvoiceIds.length > 0 && (
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleHideInvoices();
                }}
              >
                Hide Invoice
              </button>
            )}
          </div>
          <div style={{ display: "block", overflowX: "auto" }}>
            <table className="table_my">
              <thead
                className="bg-dark text-white head-row"
                style={{
                  height: "50px",
                  borderTopLeftRadius: "20px !important",
                }}
              >
                <tr className="">
                  <th
                    style={{
                      fontSize: "16px",
                      fontWeight: "normal",
                      width: "50px",
                    }}
                  >
                    <div
                      style={{ marginLeft: "10px" }}
                      className="d-flex justify-content-center"
                    >
                      <input
                        type="checkbox"
                        checked={
                          items_data.length > 0 &&
                          selectedInvoiceIds.length === items_data.length
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            // Select all
                            setSelectedInvoiceIds(
                              items_data.map((item) => item.slug || item.id)
                            );
                          } else {
                            // Deselect all
                            setSelectedInvoiceIds([]);
                          }
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </th>
                  <th
                    style={{
                      fontSize: "16px",
                      fontWeight: "normal",
                      width: "166px",
                    }}
                  >
                    <p className="ms-3 my-auto">Invoice No</p>
                  </th>

                  <th
                    style={{
                      fontSize: "16px",
                      fontWeight: "normal",
                      width: "147px",
                    }}
                  >
                    Delivery Status
                  </th>

                  <th
                    style={{
                      fontSize: "16px",
                      fontWeight: "normal",
                      width: "130px",
                    }}
                  >
                    Status
                  </th>

                  <th
                    style={{
                      fontSize: "16px",
                      fontWeight: "normal",
                      width: "170px",
                    }}
                  >
                    Payment Type
                  </th>

                  <th
                    style={{
                      fontSize: "16px",
                      fontWeight: "normal",
                      width: "120px",
                    }}
                  >
                    Total
                  </th>

                  <th
                    style={{
                      fontSize: "16px",
                      fontWeight: "normal",
                      width: "130px",
                    }}
                  >
                    Create On
                  </th>
                  <th
                    style={{
                      fontSize: "16px",
                      fontWeight: "normal",
                      width: "140px",
                    }}
                  >
                    Last Modified
                  </th>
                  <th
                    style={{
                      fontSize: "16px",
                      fontWeight: "normal",
                      width: "140px",
                    }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="tb">
                {items_data.length > 0 && items_data ? (
                  items_data.map((category, index) => {
                    const invoiceId = category.slug || category.id;
                    const isSelected = selectedInvoiceIds.includes(invoiceId);

                    return (
                      <tr className="table-row " key={category?.slug}>
                        <td>
                          <div className="d-flex justify-content-center">
                            <input
                              type="checkbox"
                              checked={isSelected}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  // Add to selected
                                  setSelectedInvoiceIds((prev) => [
                                    ...prev,
                                    invoiceId,
                                  ]);
                                } else {
                                  // Remove from selected
                                  setSelectedInvoiceIds((prev) =>
                                    prev.filter((id) => id !== invoiceId)
                                  );
                                }
                              }}
                              style={{ cursor: "pointer", marginLeft: "12px" }}
                            />
                          </div>
                        </td>
                        <td>
                          <p className="ms-3 my-auto">{category.number}</p>
                        </td>

                        <td>
                          <button
                            className={`status1 ${
                              (category.delivery_status === 0 &&
                                "bg-danger text-white") ||
                              (category.delivery_status === 1 &&
                                "c5 text-white") ||
                              (category.delivery_status === 2 &&
                                "bg-success text-white ")
                            }`}
                          >
                            {delivery_choices[category.delivery_status]}
                          </button>
                        </td>

                        <td>{invoice_choices[category.payment_status]}</td>

                        <td> {paymentType[category?.payment_type]}</td>
                        <td>৳ {category?.total_amount}</td>

                        <td>{category?.invoice_date}</td>
                        <td className="ms-1">{category.last_modified_by}</td>
                        <td className="action">
                          <div className="d-flex justify-content-center gap-3">
                            {category?.source === 0 ? (
                              <div
                                className="edit-del blue"
                                onClick={() =>
                                  // history.push(
                                  //   `/sales/view-web-invoice/${category?.slug}`
                                  // )
                                  window.open(
                                    `/sales/view-web-invoice/${category?.slug}`,
                                    "_blank"
                                  )
                                }
                              >
                                <ViewIcon />
                              </div>
                            ) : (
                              <div
                                className="edit-del blue"
                                onClick={() =>
                                  // history.push(
                                  //   `/sales/view-invoice/${category?.slug}`
                                  // )
                                  window.open(
                                    `/sales/view-invoice/${category?.slug}`,
                                    "_blank"
                                  )
                                }
                              >
                                <ViewIcon />
                              </div>
                            )}

                            <div
                              className="edit-del blue"
                              onClick={() => {
                                if (category?.payment_status === 3) {
                                  // showToast('success','Edit Exchange Invoice Currently Unavailable')
                                  history.push(
                                    `/outlet/edit_exchange_invoice/${category?.slug}`
                                  );
                                } else {
                                  history.push(
                                    `/outlet/edit_invoice/${category?.slug}`
                                  );
                                }
                              }}
                            >
                              <EditIcon />
                            </div>

                            {has_permissions(can_delete_invoice) ? (
                              <div
                                className="edit-del red"
                                onClick={() => deleteData(category?.slug)}
                              >
                                <DeleteIcon />
                              </div>
                            ) : (
                              <div
                                className="edit-del red"
                                onClick={() =>
                                  swal(
                                    "Sorry , You are not able to delete invoice."
                                  )
                                }
                              >
                                <DeleteIcon />
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="10">
                      <div className="not_found d-flex justify-content-center align-items-center py-4">
                        <h4 className="my-4">No Data Found</h4>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* ----------2nd Table for pdf print------*/}
          {/* entites and paggination */}
          {totalData > 0 && (
            <div className="row pag" style={{ marginTop: "30px" }}>
              <div className="col-6 col-md-5">
                <p
                  className="inter"
                  style={{ color: "#AEAEB2", fontSize: "16px" }}
                >
                  Total Entries:{" "}
                  <span style={{ color: "black", fontSize: "14px" }}>
                    {totalData}
                  </span>
                  <span className="ms-2"></span>
                  Total Page:{" "}
                  <span style={{ color: "black", fontSize: "14px" }}>
                    {Math.ceil(totalData / 20)}
                  </span>
                </p>
              </div>
              {/* <div className="col-12 col-md-6 d-flex paggination-button">
              <ReactPaginate
                previousLabel={<PreviousIcon />}
                nextLabel={<NextIcon />}
                pageCount={pageCount}
                onPageChange={changePage}
                containerClassName={"paginationBttns"}
                previousLinkClassName={"a"}
                nextLinkClassName={"a"}
                disabledClassName={"paginationDisabled"}
                activeClassName={"paginationActive"}
                initialPage={query?.length > 0 ? 0 : updatedPageNumber}
                forcePage={
                  query?.length > 0 || getData?.length < usersPerPage
                    ? 0
                    : updatedPageNumber
                }
              />
            </div> */}
              <div className="col-12 col-md-6 d-flex paggination-button">
                <>
                  <div className="row lead_pagination bg-transparent">
                    <div className="col-12 col-lg-6 d-flex justify-content-lg-end justify-content-md-end  col-md-6 col-sm-6  col-xs-12 pagination_container">
                      <nav aria-label="...">
                        <ul className="pagination pagination-sm">
                          {!loading ? (
                            <li className="page-item ">
                              {prevUrl !== null ? (
                                <Link
                                  onClick={handlePaginationPrevious}
                                  className={` ${
                                    prevUrl === null ? "disabled" : ""
                                  } page-link pagination_texts  pagination_btn font_size_for_small py-1 mt-1 me-3 a`}
                                  to="#"
                                  tabindex="-1"
                                >
                                  <PreviousIcon />
                                </Link>
                              ) : (
                                <Link
                                  onClick={() =>
                                    showToast(
                                      "success",
                                      "You are on first page"
                                    )
                                  }
                                  className={` ${
                                    prevUrl === null ? "disabled" : ""
                                  } page-link pagination_texts pagination_btn font_size_for_small me-3 py-1 mt-1 a`}
                                  to="#"
                                  tabindex="-1"
                                >
                                  <PreviousIcon />
                                </Link>
                              )}
                            </li>
                          ) : (
                            <li className="page-item ">
                              <Link
                                className={` ${
                                  prevUrl === null ? "disabled" : ""
                                } page-link pagination_texts pagination_btn font_size_for_small me-3 py-1 mt-1 a`}
                                to="#"
                                tabindex="-1"
                              >
                                <PreviousIcon />
                              </Link>
                            </li>
                          )}

                          {[...Array(pageCount === null ? 1 : pageCount)].map(
                            (elem, index) => (
                              <li
                                className="page-item"
                                style={{
                                  display: `${
                                    index + 1 !== pageNumber ? "none" : "block"
                                  }`,
                                }}
                              >
                                {/*  style={{
                      display: `${index + 1 !== pageNumber ? "none" : "block"}`,
                    }} */}
                                {/* setPageNumber(prev=> prev - 1) */}

                                <Link
                                  onClick={() =>
                                    handleChangeCurrentPage(index + 1)
                                  }
                                  className={`${
                                    index + 1 == pageNumber
                                      ? "paginationActive"
                                      : ""
                                  } page-link lead_page_link lead_page_link1 font_size_for_small pagination_texts px-2 text-dark`}
                                  to="#"
                                >
                                  <span className="px-1 py-1">
                                    {pageNumber}
                                  </span>
                                </Link>
                              </li>
                            )
                          )}
                          {!loading ? (
                            <li className="page-item">
                              {nextUrl !== null ? (
                                <Link
                                  onClick={handlePaginationNext}
                                  className={`${
                                    nextUrl === null ? "disabled" : ""
                                  } page-link pagination_btn font_size_for_small pagination_texts py-1 mt-1 ms-3 a`}
                                  to="#"
                                >
                                  <NextIcon />{" "}
                                </Link>
                              ) : (
                                <Link
                                  onClick={() =>
                                    showToast("success", "You are on last page")
                                  }
                                  className={`${
                                    nextUrl === null ? "disabled" : ""
                                  } page-link pagination_btn font_size_for_small pagination_texts py-1 mt-1 ms-3 a`}
                                  to="#"
                                >
                                  <NextIcon />
                                </Link>
                              )}
                            </li>
                          ) : (
                            <li className="page-item">
                              <Link
                                className={`${
                                  nextUrl === null ? "disabled" : ""
                                } page-link pagination_btn font_size_for_small pagination_texts py-1 mt-1 ms-3 a`}
                                to="#"
                              >
                                <NextIcon />
                              </Link>
                            </li>
                          )}
                        </ul>
                      </nav>
                    </div>
                  </div>
                </>
              </div>
            </div>
          )}
        </div>
        <br />
        <div className="invoice-main ">
          <div className="head-select my-2 d-flex justify-content-between align-items-center">
            <div>
              <h5>Outlet Invoice Hidden</h5>
              <input
                type="text"
                style={{ color: "black" }}
                className="filter-input"
                placeholder="Search here"
                onChange={(e) => {
                  setQueryHidden(e.target.value);
                }}
              />
            </div>
            {selectedHiddenInvoiceIds.length > 0 && (
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleShowInvoices();
                }}
              >
                Show Invoice
              </button>
            )}
          </div>
          <div style={{ display: "block", overflowX: "auto" }}>
            <table className="table_my">
              <thead
                className="bg-dark text-white head-row"
                style={{
                  height: "50px",
                  borderTopLeftRadius: "20px !important",
                }}
              >
                <tr className="">
                  <th
                    style={{
                      fontSize: "16px",
                      fontWeight: "normal",
                      width: "50px",
                    }}
                  >
                    <div
                      style={{ marginLeft: "10px" }}
                      className="d-flex justify-content-center"
                    >
                      <input
                        type="checkbox"
                        checked={
                          items_data_hidden.length > 0 &&
                          selectedHiddenInvoiceIds.length ===
                            items_data_hidden.length
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            // Select all
                            setSelectedHiddenInvoiceIds(
                              items_data_hidden.map(
                                (item) => item.slug || item.id
                              )
                            );
                          } else {
                            // Deselect all
                            setSelectedHiddenInvoiceIds([]);
                          }
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </th>
                  <th
                    style={{
                      fontSize: "16px",
                      fontWeight: "normal",
                      width: "166px",
                    }}
                  >
                    <p className="ms-3 my-auto">Invoice No</p>
                  </th>

                  <th
                    style={{
                      fontSize: "16px",
                      fontWeight: "normal",
                      width: "147px",
                    }}
                  >
                    Delivery Status
                  </th>

                  <th
                    style={{
                      fontSize: "16px",
                      fontWeight: "normal",
                      width: "130px",
                    }}
                  >
                    Status
                  </th>

                  <th
                    style={{
                      fontSize: "16px",
                      fontWeight: "normal",
                      width: "170px",
                    }}
                  >
                    Payment Type
                  </th>

                  <th
                    style={{
                      fontSize: "16px",
                      fontWeight: "normal",
                      width: "120px",
                    }}
                  >
                    Total
                  </th>

                  <th
                    style={{
                      fontSize: "16px",
                      fontWeight: "normal",
                      width: "130px",
                    }}
                  >
                    Create On
                  </th>
                  <th
                    style={{
                      fontSize: "16px",
                      fontWeight: "normal",
                      width: "140px",
                    }}
                  >
                    Last Modified
                  </th>
                  <th
                    style={{
                      fontSize: "16px",
                      fontWeight: "normal",
                      width: "140px",
                    }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="tb">
                {items_data_hidden.length > 0 && items_data_hidden ? (
                  items_data_hidden.map((category, index) => {
                    const invoiceId = category.slug || category.id;
                    const isSelected =
                      selectedHiddenInvoiceIds.includes(invoiceId);

                    return (
                      <tr className="table-row " key={category?.slug}>
                        <td>
                          <div className="d-flex justify-content-center">
                            <input
                              type="checkbox"
                              checked={isSelected}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  // Add to selected
                                  setSelectedHiddenInvoiceIds((prev) => [
                                    ...prev,
                                    invoiceId,
                                  ]);
                                } else {
                                  // Remove from selected
                                  setSelectedHiddenInvoiceIds((prev) =>
                                    prev.filter((id) => id !== invoiceId)
                                  );
                                }
                              }}
                              style={{ cursor: "pointer", marginLeft: "12px" }}
                            />
                          </div>
                        </td>
                        <td>
                          <p className="ms-3 my-auto">{category.number}</p>
                        </td>

                        <td>
                          <button
                            className={`status1 ${
                              (category.delivery_status === 0 &&
                                "bg-danger text-white") ||
                              (category.delivery_status === 1 &&
                                "c5 text-white") ||
                              (category.delivery_status === 2 &&
                                "bg-success text-white ")
                            }`}
                          >
                            {delivery_choices[category.delivery_status]}
                          </button>
                        </td>

                        <td>{invoice_choices[category.payment_status]}</td>

                        <td> {paymentType[category?.payment_type]}</td>
                        <td>৳ {category?.total_amount}</td>

                        <td>{category?.invoice_date}</td>
                        <td className="ms-1">{category.last_modified_by}</td>
                        <td className="action">
                          <div className="d-flex justify-content-center gap-3">
                            {category?.source === 0 ? (
                              <div
                                className="edit-del blue"
                                onClick={() =>
                                  // history.push(
                                  //   `/sales/view-web-invoice/${category?.slug}`
                                  // )
                                  window.open(
                                    `/sales/view-web-invoice/${category?.slug}`,
                                    "_blank"
                                  )
                                }
                              >
                                <ViewIcon />
                              </div>
                            ) : (
                              <div
                                className="edit-del blue"
                                onClick={() =>
                                  // history.push(
                                  //   `/sales/view-invoice/${category?.slug}`
                                  // )
                                  window.open(
                                    `/sales/view-invoice/${category?.slug}`,
                                    "_blank"
                                  )
                                }
                              >
                                <ViewIcon />
                              </div>
                            )}

                            <div
                              className="edit-del blue"
                              onClick={() => {
                                if (category?.payment_status === 3) {
                                  // showToast('success','Edit Exchange Invoice Currently Unavailable')
                                  history.push(
                                    `/outlet/edit_exchange_invoice/${category?.slug}`
                                  );
                                } else {
                                  history.push(
                                    `/outlet/edit_invoice/${category?.slug}`
                                  );
                                }
                              }}
                            >
                              <EditIcon />
                            </div>

                            {has_permissions(can_delete_invoice) ? (
                              <div
                                className="edit-del red"
                                onClick={() => deleteData(category?.slug)}
                              >
                                <DeleteIcon />
                              </div>
                            ) : (
                              <div
                                className="edit-del red"
                                onClick={() =>
                                  swal(
                                    "Sorry , You are not able to delete invoice."
                                  )
                                }
                              >
                                <DeleteIcon />
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="10">
                      <div className="not_found d-flex justify-content-center align-items-center py-4">
                        <h4 className="my-4">No Data Found</h4>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* ----------2nd Table for pdf print------*/}
          {/* entites and paggination */}
          {totalDataHidden > 0 && (
            <div className="row pag" style={{ marginTop: "30px" }}>
              <div className="col-6 col-md-5">
                <p
                  className="inter"
                  style={{ color: "#AEAEB2", fontSize: "16px" }}
                >
                  Total Entries:{" "}
                  <span style={{ color: "black", fontSize: "14px" }}>
                    {totalDataHidden}
                  </span>
                  <span className="ms-2"></span>
                  Total Page:{" "}
                  <span style={{ color: "black", fontSize: "14px" }}>
                    {Math.ceil(totalDataHidden / 20)}
                  </span>
                </p>
              </div>
              <div className="col-12 col-md-6 d-flex paggination-button">
                <>
                  <div className="row lead_pagination bg-transparent">
                    <div className="col-12 col-lg-6 d-flex justify-content-lg-end justify-content-md-end  col-md-6 col-sm-6  col-xs-12 pagination_container">
                      <nav aria-label="...">
                        <ul className="pagination pagination-sm">
                          {!loading ? (
                            <li className="page-item ">
                              {prevUrlHidden !== null ? (
                                <Link
                                  onClick={handlePaginationPreviousHidden}
                                  className={` ${
                                    prevUrlHidden === null ? "disabled" : ""
                                  } page-link pagination_texts  pagination_btn font_size_for_small py-1 mt-1 me-3 a`}
                                  to="#"
                                  tabindex="-1"
                                >
                                  <PreviousIcon />
                                </Link>
                              ) : (
                                <Link
                                  onClick={() =>
                                    showToast(
                                      "success",
                                      "You are on first page"
                                    )
                                  }
                                  className={` ${
                                    prevUrlHidden === null ? "disabled" : ""
                                  } page-link pagination_texts pagination_btn font_size_for_small me-3 py-1 mt-1 a`}
                                  to="#"
                                  tabindex="-1"
                                >
                                  <PreviousIcon />
                                </Link>
                              )}
                            </li>
                          ) : (
                            <li className="page-item ">
                              <Link
                                className={` ${
                                  prevUrlHidden === null ? "disabled" : ""
                                } page-link pagination_texts pagination_btn font_size_for_small me-3 py-1 mt-1 a`}
                                to="#"
                                tabindex="-1"
                              >
                                <PreviousIcon />
                              </Link>
                            </li>
                          )}

                          {[
                            ...Array(
                              pageCountHidden === null ? 1 : pageCountHidden
                            ),
                          ].map((elem, index) => (
                            <li
                              className="page-item"
                              style={{
                                display: `${
                                  index + 1 !== pageNumberHidden
                                    ? "none"
                                    : "block"
                                }`,
                              }}
                            >
                              <Link
                                onClick={() =>
                                  handleChangeCurrentPageHidden(index + 1)
                                }
                                className={`${
                                  index + 1 == pageNumberHidden
                                    ? "paginationActive"
                                    : ""
                                } page-link lead_page_link lead_page_link1 font_size_for_small pagination_texts px-2 text-dark`}
                                to="#"
                              >
                                <span className="px-1 py-1">
                                  {pageNumberHidden}
                                </span>
                              </Link>
                            </li>
                          ))}
                          {!loading ? (
                            <li className="page-item">
                              {nextUrlHidden !== null ? (
                                <Link
                                  onClick={handlePaginationNextHidden}
                                  className={`${
                                    nextUrlHidden === null ? "disabled" : ""
                                  } page-link pagination_btn font_size_for_small pagination_texts py-1 mt-1 ms-3 a`}
                                  to="#"
                                >
                                  <NextIcon />{" "}
                                </Link>
                              ) : (
                                <Link
                                  onClick={() =>
                                    showToast("success", "You are on last page")
                                  }
                                  className={`${
                                    nextUrlHidden === null ? "disabled" : ""
                                  } page-link pagination_btn font_size_for_small pagination_texts py-1 mt-1 ms-3 a`}
                                  to="#"
                                >
                                  <NextIcon />
                                </Link>
                              )}
                            </li>
                          ) : (
                            <li className="page-item">
                              <Link
                                className={`${
                                  nextUrlHidden === null ? "disabled" : ""
                                } page-link pagination_btn font_size_for_small pagination_texts py-1 mt-1 ms-3 a`}
                                to="#"
                              >
                                <NextIcon />
                              </Link>
                            </li>
                          )}
                        </ul>
                      </nav>
                    </div>
                  </div>
                </>
              </div>
            </div>
          )}
        </div>

        <br />
        <ExchangeOutletList />
      </div>
    </div>
  );
};

export default ViewOutlet;
